import Context from 'context/appContext';
import { useContext, useEffect, useState } from 'react';

// @styles 
import './styles.scss'

export default function SmallSwitch({ info, index, handleClick }) {
    const [defaultClass, setDefaultClass] = useState('default');
    const [isClassAux, setIsClassAux] = useState(false);
    const { formStatus: { isGoToBack }, isClassActive, setIsClassActive } = useContext(Context);

    useEffect(() => {
        if (!isGoToBack && !isClassActive[0]) {
            setIsClassAux(isClassActive[index]);
             onClick();
        }else {
            !isClassActive[0] && onClick();
        }
    }, []);

    const onClick = () => {
        setDefaultClass('active-btn-left');
        handleClick(info, isClassAux);
        setIsClassAux(!isClassAux);
        setIsClassActive({ ...isClassActive, [index]: !isClassAux, [0]: isClassAux });
    };

    return (
        <div className='smallswitch__container' id={index}>
            <div className='smallswitch__container__buttons' id={index}>
                <button className={`smallswitch__container__buttons-btn ${isClassAux && defaultClass}`}
                    disabled={isClassAux}
                    onClick={() => onClick()}>
                    <span>No</span>
                </button>
                <button className={`smallswitch__container__buttons-btn ${!isClassAux ? 'active-btn-right' : ''}`}
                    disabled={!isClassAux}
                    onClick={() => onClick()}>
                    <span>Si</span>
                </button>
            </div>
        </div>
    )
}